import React, { FC, useContext } from 'react';
import { ContentContext } from '../../index.contexts';
import { StyledFlexibleDateCheckBox } from './flexibleDate.styles';
import { FlexibleDateType } from './flexibleDtae.types';

const FlexibleDate: FC<FlexibleDateType> = ({ onChange, checked }) => {
  const timestamp = new Date().getTime();
  const checkboxId = timestamp.toString() + '-flexible-date-checkbox';
  const { myDatesFlexibleLabel } = useContext(ContentContext);
  return (
    <StyledFlexibleDateCheckBox
      data-component-name="a-shop-FlexibleDates"
      data-testid="shop-FlexibleDates"
      className={'search__flexible_date'}
      variation={'simple'}
      checkboxLabel={myDatesFlexibleLabel}
      checkboxId={checkboxId}
      checkboxName="flexibleDateSearch"
      onChange={onChange}
      checked={checked}
      size={18}
      value="on"
    />
  );
};

export default FlexibleDate;
